import React from 'react';
import { Skeleton } from '@mui/material';
import { LegendContainer } from '../../styled';

export const ChartHeaderSkeleton: React.FC = () => (
  <LegendContainer sx={{ alignSelf: 'flex-end', mb: 2, mt: 0 }}>
    <Skeleton variant="rectangular" width={120} height={40} />
  </LegendContainer>
);
